import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import FilterPills from '../../../Components/FilterPills'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { formatPrice, getStatusClasses, capitalize, BOOKING_STATUS_COLORS } from '../../../utils/formatters'

export default function Index({
  account,
  accounts,
  navigation,
  bookings,
  statuses,
  params = {},
  pagination
}) {
  const handleStatusFilterChange = (status) => {
    router.visit('/manage/bookings', {
      data: { ...params, status: status || undefined, page: undefined },
      preserveState: true,
      preserveScroll: true
    })
  }

  const formatBookingDate = (dateStr) => {
    if (!dateStr) return ''
    const date = new Date(dateStr + 'T00:00:00')
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
  }

  const columns = [
    {
      key: 'booking_reference',
      label: 'Reference',
      sortable: false,
      render: (value) => (
        <span className="font-mono text-sm text-gray-900">{value}</span>
      )
    },
    {
      key: 'guest_name',
      label: 'Guest',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">{value}</div>
          <div className="text-sm text-gray-500">{item.guest_email}</div>
        </div>
      )
    },
    {
      key: 'date',
      label: 'Date & Time',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="text-gray-900">{formatBookingDate(value)}</div>
          <div className="text-sm text-gray-500">{item.time}</div>
        </div>
      )
    },
    {
      key: 'party_size',
      label: 'Guests',
      className: 'text-gray-500'
    },
    {
      key: 'venue_name',
      label: 'Venue',
      render: (value) => value || '–'
    },
    {
      key: 'total_pence',
      label: 'Total',
      sortable: true,
      className: 'font-medium text-gray-900',
      render: (value) => formatPrice(value)
    },
    {
      key: 'status',
      label: 'Status',
      render: (value) => (
        <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${getStatusClasses(value, BOOKING_STATUS_COLORS)}`}>
          {capitalize(value.replace('_', ' '))}
        </span>
      )
    }
  ]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Bookings"
    >
      <ResourceIndexHeader
        count={pagination?.count || bookings.length}
        singular="booking"
        plural="bookings"
        addHref="/manage/bookings/new"
        addLabel="New Booking"
      />

      <div className="mb-6">
        <FilterPills
          items={statuses}
          value={params.status}
          onChange={handleStatusFilterChange}
          allLabel="All Statuses"
        />
      </div>

      <DataTable
        data={bookings}
        columns={columns}
        actions={(item) => (
          <Button link href={`/manage/bookings/${item.id}`}>View</Button>
        )}
        searchable={true}
        searchPlaceholder="Search by name, email, phone, or reference..."
        emptyState={{
          message: 'No bookings found',
          action: { label: 'Create your first booking', href: '/manage/bookings/new' }
        }}
        baseUrl="/manage/bookings"
        params={params}
        pagination={pagination}
      />
    </Layout>
  )
}
